import { Injectable } from '@angular/core';
import { ResumoFinanceiroModel, TitulosLiquidadosModel, ComparacaoTitulosLiquidadosModel } from '@app/data';
import { ApiService } from '@app/gateway';
import type { DashPeriodQueryPayload } from '@app/pages/dashboard/shared';

@Injectable({ providedIn: 'root' })
export class PagarService {
  constructor(protected readonly apiService: ApiService) {}

  public async pagarTitulos(data: DashPeriodQueryPayload): Promise<TitulosLiquidadosModel[]> {
    try {
      const path: string = `pagar/pagarTitulos`;
      const result: TitulosLiquidadosModel[] = await this.apiService.post({ path, data });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load payable titles.';
      throw new Error(message, { cause: e });
    }
  }

  public async pagarTitulosVencidos(data: DashPeriodQueryPayload): Promise<ResumoFinanceiroModel> {
    try {
      const path: string = `pagar/titulosVencidos`;
      const result: ResumoFinanceiroModel = await this.apiService.post({ path, data });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load overdue payables.';
      throw new Error(message, { cause: e });
    }
  }

  public async pagarTitulosLiquidados(data: DashPeriodQueryPayload): Promise<ResumoFinanceiroModel> {
    try {
      const path: string = `pagar/titulosLiquidados`;
      const result: ResumoFinanceiroModel = await this.apiService.post({ path, data });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load settled payables.';
      throw new Error(message, { cause: e });
    }
  }

  public async pagarTitulosVencidosAberto(data: DashPeriodQueryPayload): Promise<ResumoFinanceiroModel> {
    try {
      const path: string = `pagar/titulosVencidosAberto`;
      const result: ResumoFinanceiroModel = await this.apiService.post({ path, data });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load open overdue payables.';
      throw new Error(message, { cause: e });
    }
  }

  public async pagarTitulosAtrasados(data: DashPeriodQueryPayload): Promise<ResumoFinanceiroModel> {
    try {
      const path: string = `pagar/titulosAtrasados`;
      const result: ResumoFinanceiroModel = await this.apiService.post({ path, data });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load late payables.';
      throw new Error(message, { cause: e });
    }
  }

  public async pagarComparacaoTitulosLiquidados(
    data: Pick<DashPeriodQueryPayload, 'idAccounts'> & { anos: number[] }
  ): Promise<ComparacaoTitulosLiquidadosModel[]> {
    try {
      const path: string = `pagar/comparacaoTitulosLiquidados`;
      const result: ComparacaoTitulosLiquidadosModel[] = await this.apiService.post({ path, data });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load payable comparison.';
      throw new Error(message, { cause: e });
    }
  }
}
